import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { downgradeInjectable } from '@angular/upgrade/static';

import { SteamNewsService } from './steam-news.service';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        BrowserAnimationsModule
    ],
    declarations: [
    ],
    exports: [
    ],
    providers: [
        SteamNewsService
    ],
    entryComponents: [
    ]
})
export class SteamNewsModule {
    constructor() {
    }
}

declare const angular: angular.IAngularStatic;

angular.module('app')
    .factory('SteamNewsService', downgradeInjectable(SteamNewsService) as any);
